import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { initializeAnalytics } from "../analytics";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const consent = window.localStorage.getItem("queme_cookie_consent");
    if (consent === "accepted") initializeAnalytics();
    if (!consent) setVisible(true);
  }, []);
  if (!visible) return null;
  const choose = (value) => {
    window.localStorage.setItem("queme_cookie_consent", value);
    setVisible(false);
    if (value === "accepted") initializeAnalytics();
  };
  return (
    <aside className="cookie-banner" role="dialog" aria-label="Cookie preferences">
      <div><strong>Cookies and analytics</strong><p>We use essential storage to keep QueMe working and optional analytics to improve the experience. <Link to="/privacy">Read our Privacy Policy</Link>.</p></div>
      <div className="cookie-actions"><button className="button secondary" onClick={() => choose("rejected")}>Reject</button><button className="button" onClick={() => choose("accepted")}>Accept</button></div>
    </aside>
  );
}

